import React from 'react';
import { TokenCategory } from '../stores/data/types';
import { TOKEN_CATEGORY_LABELS } from '../stores/data/types/feTokenState';

interface CategoryChipProps {
  category: TokenCategory | string | undefined;
  className?: string;
}

const CategoryChip: React.FC<CategoryChipProps> = ({ category, className = '' }) => {
  const getCategoryChipStyle = (category: TokenCategory | string | undefined): string => {
    if (!category || category === TokenCategory.NONE || category === 'None') {
      return 'bg-gray-800 border-slate-700 text-gray-400';
    }
    switch (category) {
      case TokenCategory.RANDOM:
        return 'bg-purple-600 border-purple-500 text-white';
      case TokenCategory.PROJECT:
        return 'bg-green-600 border-green-500 text-white';
      case TokenCategory.NEWS:
        return 'bg-orange-600 border-orange-500 text-white';
      case TokenCategory.TIKTOK:
        return 'bg-sky-600 border-sky-500 text-white';
      default:
        return 'bg-gray-800 border-slate-700 text-gray-400';
    }
  };

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[60px] h-6 px-3 rounded-full text-[10px] border ${getCategoryChipStyle(category)} ${className}`}
    >
      {TOKEN_CATEGORY_LABELS[category as TokenCategory] || ''}
    </span>
  );
};

export default CategoryChip;
